"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MEDIA_PLAYER_VOLUME_CHANGE = exports.MEDIA_PLAYER_TOGGLE_PLAY = void 0;
var MEDIA_PLAYER_TOGGLE_PLAY = exports.MEDIA_PLAYER_TOGGLE_PLAY = 'MEDIA_PLAYER_TOGGLE_PLAY';
var MEDIA_PLAYER_VOLUME_CHANGE = exports.MEDIA_PLAYER_VOLUME_CHANGE = 'MEDIA_PLAYER_VOLUME_CHANGE';